module.exports = "https://www.gc-pro.gnp.com.mx/420a477173798973cf0f8825298d3e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/facturas/1.png
// module id = 1031
// module chunks = 0 1